import { FC, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Flash } from 'roadie-ui'
import { useLocalization } from 'localization'
import type { TranslationKey } from 'localization'

type LocalizedFlashMessage = Flash.FlashMessage & {
  messageKey?: TranslationKey
  messageParams?: Record<string, string | number>
}

type Config = {
  flashStack: LocalizedFlashMessage[]
  modalOpen: boolean
}

type FlashConnectorProps = Omit<Flash.FlashControllerProps, 'flash' | 'onClose'>

const FlashConnector: FC<FlashConnectorProps> = (props) => {
  const { t } = useLocalization()
  const flash = useSelector((state) => {
    // @ts-expect-error config is not defined on Default State type
    const config: Config = state.config
    const flash = config.flashStack.length ? config.flashStack[config.flashStack.length - 1] : null
    return flash
  })
  const localizedFlash = flash?.messageKey ? { ...flash, message: t(flash.messageKey, flash.messageParams) } : flash

  const dispatch = useDispatch()

  const handleClose = useCallback(() => {
    dispatch({ type: 'POP_FLASH' })
  }, [dispatch])

  return <Flash.FlashController {...props} flash={localizedFlash} onClose={handleClose} />
}

export default FlashConnector
